import { MutableRefObject } from "react";
import { getMikeElements } from "../components/conversationDetail/components/conversationMessages/helpers/copilotMessageElement";

export const setScrollByMikeId = (
  mikeId?: string,
  isProgramaticScrollRef?: MutableRefObject<boolean>,
) => {
  const querySelectorKey = `[data-mike-id="${mikeId}"]`;
  const foundElement = document.querySelector(querySelectorKey);
  let initializedCheckInterval: NodeJS.Timeout;
  let checkHasElementInterval: NodeJS.Timeout;
  let initializedLastElementCheckInterval: NodeJS.Timeout;
  if (foundElement) {
    foundElement.scrollIntoView({ block: "end", behavior: "smooth" });
    if (isProgramaticScrollRef) isProgramaticScrollRef.current = true;

    initializedCheckInterval = setInterval(() => {
      const initialized = foundElement.getAttribute("data-mike-initialized");
      if (initialized) {
        clearInterval(initializedCheckInterval);
        foundElement.scrollIntoView({ block: "start", behavior: "smooth" });
        if (isProgramaticScrollRef) isProgramaticScrollRef.current = true;
      }
    }, 1000);
  } else {
    checkHasElementInterval = setInterval(() => {
      const mikeElements = getMikeElements();

      if (mikeElements.length > 0) {
        document
          .querySelector("#mikeMessagesScrollWrapper")
          ?.scrollIntoView({ block: "end", behavior: "smooth" });
        if (isProgramaticScrollRef) isProgramaticScrollRef.current = true;

        clearInterval(checkHasElementInterval);

        initializedLastElementCheckInterval = setInterval(() => {
          const initialized = mikeElements[
            mikeElements.length - 1
          ].getAttribute("data-mike-initialized");
          if (initialized) {
            clearInterval(initializedLastElementCheckInterval);
            mikeElements[mikeElements.length - 1].scrollIntoView({
              block: "start",
              behavior: "smooth",
            });
            if (isProgramaticScrollRef) isProgramaticScrollRef.current = true;
          }
        }, 1000);
      }
    }, 1000);
  }

  return () => {
    clearInterval(initializedCheckInterval);
    clearInterval(checkHasElementInterval);
    clearInterval(initializedLastElementCheckInterval);
  };
};
